export default __webpack_public_path__ + "static/media/Roboto-Bold.6490694b.eot";